import { Directive, OnInit, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { map } from 'rxjs/operators';

import { Permission } from '../enums/enums';
import { PermissionsService } from '../services/permissions-service';

@Directive({
    selector: '[featureFlag]'
  })
export class FeatureFlagDirective {
    @Input() set featureFlag(featureFlag) {
        this.enableView(featureFlag);
    }
    constructor(
        private tpl: TemplateRef<any>,
        private vcr: ViewContainerRef,
        private permissionsService: PermissionsService
    ) {}

    private enableView(featureFlag: Permission) {
        this.permissionsService.getPermissions().pipe(map((response) => {
            return response.includes(featureFlag);
        }))
        .toPromise()
        .then(isEnabled => {
            if (isEnabled) {
                this.vcr.createEmbeddedView(this.tpl);
            }
        });

    }
}